module.exports = __webpack_public_path__ + "static/media/679.ad7cf61f.webp";